import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './LogCommonCell.css';

export interface LogCommonCellProps {
    capitalize?: boolean;
}

export class LogCommonCell extends React.PureComponent<LogCommonCellProps> {
    render() {
        const { children, capitalize } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: 'log-common-cell',
                    mods: {
                        capitalized: Boolean(capitalize)
                    }
                })}
            >
                {children || '–'}
            </div>
        );
    }
}
